import React from 'react';
import ToolLayout from '../../components/ToolLayout';
import WordCounter from '../../components/WordCounter';

const WordCountPage: React.FC = () => (
  <ToolLayout
    title="Word Counter - Count Words & Characters Online | AllTools"
    description="Count words, characters, sentences, and paragraphs. Reading time estimate and word frequency. Free tool."
    canonicalPath="/word-counter"
  >
    <WordCounter />
  </ToolLayout>
);

export default WordCountPage;
